/** @jsxImportSource @emotion/react */
import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

interface SingleRowProps {
  textLeft: string;
  textRight: string;
}

const SingleRow = ({ textLeft, textRight }: SingleRowProps) => {
  return (
    <Typography variant="body3Regular" color={colors.textSecondary}>
      {textLeft}:{" "}
      <Typography
        component="span"
        variant="body3Regular"
        color={colors.textDark}
      >
        {textRight}
      </Typography>
    </Typography>
  );
};

export default SingleRow;
